import React, { useEffect } from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import FormControlLabel from '@mui/material/FormControlLabel';
import TextField from '@mui/material/TextField';
import Checkbox from '@mui/material/Checkbox';
import { cleverTap, getAppointmentDate, getAppointmentTime } from "../../../services/provider/common";
import { SingleConfirmAppointments, BulkConfirmAppointments } from "../../../services/provider/appointment";
import { CLEVER_TAP_EVENTS, STATUS_CODE_MAP } from '../../../constants/provider/constant';
import { useLocation } from 'react-router';
import { toast } from "react-toast";


export default function ConfirmAppointmentDialog(props) {

    const location = useLocation();
    const [details] = React.useState(props.details);
    const [selected] = React.useState(props.selected);
    const [bulkFlag] = React.useState(props.bulkFlag);
    const [notes, setNotes] = React.useState('');
    const [homeVisitBy, setHomevistBy] = React.useState([{ id: 'HOME_VISIT_BY_DOCTOR', label: 'Doctor', checked: false }, { id: 'HOME_VISIT_BY_LAB_TECHNICIAN', label: 'LAB Technician', checked: false }, { id: 'HOME_VISIT_BY_ECG_TECHNICIAN', label: 'ECG Technician', checked: false }, { id: 'HOME_VISIT_BY_MBBS_DOCTOR', label: 'MBBS Doctor', checked: false }, { id: 'HOME_VISIT_BY_MD_DOCTOR', label: 'MD Doctor', checked: false }])
    const [count, setCount] = React.useState(0);
    const [rejectOption, setRejectOption] = React.useState("");

    useEffect(()=>{
        if(bulkFlag)
        cleverTap(CLEVER_TAP_EVENTS.bulkConfirmPopupShown, {
            srcType: "web",
            srcPage: location.pathname,
            // City: Bangalore
            requestsCount:selected.length,
            isPopupShown: 1
        })
        else
        if(props.action==="confirm")
        cleverTap(CLEVER_TAP_EVENTS.confirmPopupShown, {
            RequestId: details["requestId"],
            srcType: "web/mWeb",
            isPopupShown: 1
        })
    },[bulkFlag, details, location.pathname, props.action, selected.length])

    const handleChange = (event, elem) => {
        let statuses = homeVisitBy;
        let count = 0;
        statuses = statuses.map(element => {
            if (elem.id === element.id) {
                element.checked = event.target.checked
            }
            element.checked === true ? count++ : count += 0;
            return element;
        })
        setCount(count);
        setHomevistBy(statuses);
    };

    const handleFieldChange = (event) => {
        event.preventDefault();
        const { name, value } = event.target;

        let obj = {
            fields: { key: name, value: value }
        }
        console.log("obj", obj)
        switchCase(name, value);
    }

 
    const getRequestIdFromArray = (arrayOfItems) => {
        let id =props.action==="reject"?STATUS_CODE_MAP["Rejected"] : STATUS_CODE_MAP["Confirmed by Medical Center"];
        arrayOfItems && arrayOfItems.forEach(element => {
            if (element.action === 'Confirm') id = STATUS_CODE_MAP["Confirmed by Medical Center"]
            if(props.action==="reject") id=STATUS_CODE_MAP["Rejected"]
        })
        return id;
    }

    const HomeVisitMarkedBy = () => {
        let markedCases = [];
        homeVisitBy.forEach(element => {
            if (element.checked) {
                markedCases.push(element.id);
            }
        })
        return markedCases;
    }


    const sendBulkPayload = () => {
        let payload = [];

        if (selected && selected.length > 0) {
            selected.forEach(element => {
                payload.push({ requestId: element.requestId, statusId: element.currentStatusId })
            });
        }
        return payload;
    }

    const submitDetails = (event) => {

        event.preventDefault();
        let obj = {}
        const { action } = props;
        if (bulkFlag) {
            obj = {
                requestIds: sendBulkPayload(),
                requestedNextActionId:(action === "confirm" )? STATUS_CODE_MAP["Confirmed by Medical Center"]:STATUS_CODE_MAP["Rejected"],
                remark: action==="confirm"? notes : rejectOption
            }
            if(action === "confirm"){
                cleverTap(CLEVER_TAP_EVENTS.bulkConfirmPopupBtnClick, {
                    // ProviderId: 419821
                    srcType: "web",
                    srcPage: location.pathname,
                    // Date: Jan 19 2022 23:59:59
                    // City: Bangalore
                    requestsCount:selected.length,
                    Remarks:notes
                })
            }
        } else {
            if(action==="confirm"){
            cleverTap(CLEVER_TAP_EVENTS.confirmPopupBtnClick, {
                RequestId: details.requestId,
                srcType: "web/mWeb",
                srcPage: location.pathname,
                statusInfo: "New Appointment/ Rescheduled by Ops",
                costType : details.additionalInformation.isPaid,
                visitType : details.additionalInformation.visitType,
                testCategory : details.additionalInformation.productName,
                HomevisitBy: HomeVisitMarkedBy(),
                Remarks:notes
            })
            obj = {
                requestId: details.requestId,
                contractTypeId: details.requestContractType,
                currentStatusId: details.currentStatusId,
                remarks: notes,
                requestedNextActionId: getRequestIdFromArray(details.nextPossibleActions),
                homeVisitMarkedBy: HomeVisitMarkedBy(),
            }}
            else{
            obj = {
                requestId: details.requestId,
                contractTypeId: details.requestContractType,
                currentStatusId: details.currentStatusId,
                remarks: rejectOption==="Others"?notes:rejectOption,
                requestedNextActionId: getRequestIdFromArray(details.nextPossibleActions),
            }}
        }

        let data = {
            request: obj,
            requestAccessToken: JSON.parse(localStorage.getItem("access_token")),
        }

        if (bulkFlag) {
            BulkConfirmAppointments(obj).then(res => {
                console.log("res ..", res)
                if (res.isSuccess) {
                    if(action==="confirm"){
                        cleverTap(CLEVER_TAP_EVENTS.bulkConfirmedApptSuccess, {
                            srcType: "web",
                            srcPage: location.pathname,
                            requestsCount: selected.length,
                            isSucess: 1,
                            Remarks:obj.remark
                        })
                    }
                    toast.success(`${action} appointments successful`)
                    props.closeDialogAndRefresh("REFRESH");
                }
                else{
                    if(action ==="confirm")
                    cleverTap(CLEVER_TAP_EVENTS.bulkConfirmedApptFailed,{
                        srcType: "web",
                        srcPage: location.pathname,
                        requestsCount: selected.length,
                        isSucess: 0,
                        failureReason: "",
                        Remarks:obj.remark
                    })
                    toast.error(`${action} appointments failed ${res?.errorMessage ?? ""}`)
                }
            })
        } else {
            SingleConfirmAppointments(data).then(res => {
                console.log("res ..", res)
                if (res.isSuccess) {
                    if(action === "confirm"){
                        cleverTap(CLEVER_TAP_EVENTS.confirmedApptSuccess, {
                            RequestId: details.requestId,
                            srcType: "web", 
                            HomevisitBy: HomeVisitMarkedBy(),
                            Remarks: notes,
                            srcPage: location.pathname,
                            isSuccess: 1
                        })
                    }else{
                        cleverTap(CLEVER_TAP_EVENTS.rejectApptSuccess, {
                            RequestId: details.requestId,
                            srcType: "web", 
                            HomevisitBy: HomeVisitMarkedBy(),
                            Remarks: notes,
                            isSuccess: 1
                        })
                    }
                    toast.success(`${action} appointment successful`)
                    props.closeDialogAndRefresh("REFRESH");
                }
                else{
                    if(action === "confirm")
                    cleverTap(CLEVER_TAP_EVENTS.confirmedApptFailed, {
                        RequestId: details.requestId,
                        srcType: "web", 
                        srcPage: location.pathname,
                        isSuccess: 0,
                        failureReason: "Error 404"
                    })
                    toast.error(`${action} appointment failed ${res?.errorMessage ?? ""}`)
                }
            })
        }
    }

    const closePopUp = () => {
        props.closeDialog();
    }

    const switchCase = (name, value) => {
        switch (name) {
            case 'notes':
                setNotes(value);
                break;
            default:
                break;
        }
    }

let reasons = [    "Unavailability Of Slots",    "No Bandwidth",    "Holidays", "Others"]

    const rejectionOptions = (
            Boolean(props.action==="reject")?
            <div>
            <div className="pb-5">
            <FormControl className="w-full">
                <InputLabel id="rejectOption">Reject Option</InputLabel>
                <Select
                  labelId="rejectOption"
                  name="rejectOption"
                  id="rejectOption"
                  value={rejectOption}
                  label="Reject Option"
                  onChange={(event) => { setRejectOption(event.target.value) }}
                  required
                >
                    {
                        reasons.map((ele)=>(
                            <MenuItem value={ele}>{ele}</MenuItem>
                        ))
                    }
                </Select>
              </FormControl>
        </div>
        {
                rejectOption === "Others" ?
                <div className="pb-10">
                    <FormControl className="w-full">
                        <TextField
                            sx={{ '& .MuiOutlinedInput-input, .MuiInputLabel-root': { fontSize: 14 } }}
                            id="outlined-multiline-static-reject-option"
                            label="Reason For Rejection*"
                            placeholder="Please Write reason for rejection."
                            name="reasonRejected"
                            onChange={(event) => setNotes(event.target.value)}

                            value={notes}
                        />
                    </FormControl>
                </div>
                :null
            }
        </div>
        :
        <></>
        ) 

    return (
        <div className="mt-5">
            <Box
                component="form"
                noValidate
                autoComplete="off"
                onSubmit={(event) => submitDetails(event)}
            >
                {
                    !bulkFlag ?
                        <div className="pb-5">
                            <div>
                                <span className="text-gray-600 text-sm"> Appointment Date and Time :  </span>
                                <span className="text-gray-600 font-semibold text-sm"> {getAppointmentDate(details.formattedfulfillmentDate)} {getAppointmentTime(details.formattedfulfillmentDate)} </span>
                            </div>
                        </div> : <></>
                }



                {
                    details != null && details.additionalInformation && details.additionalInformation.visitType === "Home_Visit" && !bulkFlag && props.action === "confirm" ?
                        <div>
                            <div className="pb-5">
                                <span className="text-gray-600 text-sm"> Home Visit By <span className="text-red-500 font-semibold"> * </span> :</span>
                                <div className="flex flex-wrap justify-start text-xs">
                                    {
                                        homeVisitBy && homeVisitBy.length > 0 ? homeVisitBy.map((elem,i) => (
                                            <FormControlLabel
                                                key={i}
                                                sx={{ '& .MuiFormControlLabel-label': { fontSize: 14 } }}
                                                label={elem.label}
                                                control={<Checkbox size="small" checked={elem.checked} onChange={(event) => handleChange(event, elem)} />}
                                            />
                                        )) : <></>
                                    }
                                </div>
                            </div>
                        </div>
                        : <></>
                }

                {rejectionOptions}
                
                {
                    props.action!=="reject"?
                        <div className="pb-10">
                            <FormControl className="w-full">
                                <TextField
                                    sx={{ '& .MuiOutlinedInput-input, .MuiInputLabel-root': { fontSize: 14 } }}
                                    id="outlined-multiline-static"
                                    label="Remarks*"
                                    multiline
                                    name="notes"
                                    onChange={(event) => handleFieldChange(event)}
                                    rows={4}
                                    value={notes}
                                />
                            </FormControl>
                        </div>
                    :null
                }

                <div className='pb-5 flex justify-between text-center'>
                    <div className="border border-gray-600 rounded-md w-40 text-gray-900 p-1 text-sm cursor-pointer font-semibold" type="submit" variant="contained" size="large" onClick={closePopUp}>
                        <span>
                            Cancel
                        </span>
                    </div>
                    {
                        bulkFlag ?
                            <div className={notes || (props.action==="reject" && rejectOption!=="") ? "border-green-600 bg-green-600 border cursor-pointer  text-gray-100 rounded-md w-40 p-1 text-sm font-semibold":"border-green-200 bg-green-200 border  text-black-300 rounded-md w-40 p-1 text-sm font-semibold"} variant="contained" size="large" onClick={notes || (props.action==="reject" && rejectOption!=="") ? submitDetails : undefined}>
                                <span>
                                    {
                                        props.action==="reject"?"Reject":"Confirm"
                                    }
                                </span>
                            </div> :
                            <div className={((((details && details.additionalInformation && details.additionalInformation.visitType !== "Home_Visit") || count > 0 ) && notes) || (props.action==="reject" && ((rejectOption!=="" && rejectOption!=="Others") || (rejectOption==="Others" && notes))) ) ? "border-green-600 bg-green-600 border cursor-pointer  text-gray-100 rounded-md w-40 p-1 text-sm font-semibold" : "border-green-200 bg-green-200 border  text-black-300 rounded-md w-40 p-1 text-sm font-semibold"} type="submit" variant="contained" size="large" onClick={((((details.additionalInformation.visitType !== "Home_Visit") || count > 0 || bulkFlag) && notes) || (props.action==="reject" && ((rejectOption!=="" && rejectOption!=="Others") || (rejectOption==="Others" && notes))) ) ? submitDetails : undefined}>
                                <span>  
                                    {
                                        props.action==="reject"?"Reject":"Confirm"
                                    }
                                </span>
                            </div>
                    }


                </div>
            </Box>
        </div>
    );
}